const formatFileSize = (bytes) => {
	if (bytes === 0) return "0 B";
	const k = 1024;
	const sizes = ["B", "Kb", "Mb", "GB"];

	let i = 0;
	if (bytes >= Math.pow(k, 3)) i = 3;
	else if (bytes >= Math.pow(k, 2)) i = 2;
	else if (bytes >= k) i = 1;

	const value = bytes / Math.pow(k, i);
	const rounded = Math.round(value * 10) / 10;
	const formatted = rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(1);

	return formatted + " " + sizes[i];
};

const addFileSize = (nameElement, files) => {
	let sizeText = "";
	for (let i = 0; i < files.length; i++) {
		const size = formatFileSize(files[i].size);
		const separator = i !== files.length - 1 ? " | " : "";
		sizeText += ` ${size}${separator}`;
	}

	const existingSize = nameElement.querySelector(".file-size");
	if (existingSize) {
		existingSize.remove();
	}

	const sizeSpan = document.createElement("span");
	sizeSpan.className = "file-size file-size--position";
	sizeSpan.textContent = sizeText;
	nameElement.appendChild(sizeSpan);
};

document.addEventListener("DOMContentLoaded", () => {
	const container = document.querySelector("#mfcf7_zl_multifilecontainer");
	if (!container) return;

	container.addEventListener("change", (e) => {
		if (!e.target.matches('input[type="file"]')) return;

		const input = e.target;
		const wrap = input.closest(".wpcf7-form-control-wrap");
		if (!wrap) return;

		const nameElement = wrap.querySelector(".mfcf7-zl-multifile-name");
		if (!nameElement || !input.files || input.files.length === 0) return;

		addFileSize(nameElement, Array.from(input.files));
	});
});
